<template>
  <div :class="bem()" v-if="show">

    <slot name="header"></slot>

    <slot v-for="(result, index) in results" :result="result" :resultsGrouped="resultsGrouped" :index="index">
      Result 'objectID': {{ result.objectID }}
    </slot>

    <slot name="footer"></slot>

  </div>
</template>
<script>
import { Results } from 'vue-instantsearch'
import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('searchEnginePage')
export default {
  name: 'ais-results',
  extends: Results,
  data () {
    return {
      previousResults: ''
    }
  },
  methods: {
    ...mapMutations(['setSelectAllCheckbox', 'setResultsCheckbox'])
  },
  computed: {
    resultsGrouped () {
      let results = false
      if (this.$route.name !== 'companyReports') {
        return results
      }
      if (this.stack === false) {
        results = this.searchStore.results
      } else {
        if (typeof this.stackedResults === 'undefined') {
          this.stackedResults = []
        }

        if (this.searchStore.page === 1) {
          this.stackedResults = []
        }

        if (
          this.stackedResults.length === 0 ||
          this.searchStore.results.length === 0
        ) {
          this.stackedResults.push(...this.searchStore.results)
        } else {
          const lastStacked = this.stackedResults[this.stackedResults.length - 1]
          const lastResult = this.searchStore.results[this.searchStore.results.length - 1]
          if (lastStacked.objectID !== lastResult.objectID) {
            this.stackedResults.push(...this.searchStore.results)
          }
        }
        results = this.stackedResults
      }
      let resultsGrouped = {}
      for (const result of results) {
        if (Object.keys(resultsGrouped).indexOf(result['reportId'].toString()) > -1) {
          resultsGrouped[result['reportId']].push(result)
        } else {
          resultsGrouped[result['reportId']] = [result]
        }
      }
      return resultsGrouped
    },
    results () {
      // This code is copy-pasted from the algolia instant search library
      let results = false
      if (this.stack === false) {
        results = this.searchStore.results
      } else {
        if (typeof this.stackedResults === 'undefined') {
          this.stackedResults = []
        }

        if (this.searchStore.page === 1) {
          this.stackedResults = []
        }

        if (
          this.stackedResults.length === 0 ||
          this.searchStore.results.length === 0
        ) {
          this.stackedResults.push(...this.searchStore.results)
        } else {
          const lastStacked = this.stackedResults[this.stackedResults.length - 1]
          const lastResult = this.searchStore.results[this.searchStore.results.length - 1]
          if (lastStacked.objectID !== lastResult.objectID) {
            this.stackedResults.push(...this.searchStore.results)
          }
        }
        results = this.stackedResults
      }
      if (this.$route.name !== 'companyReports') {
        return results
      }
      // Distinct results for company report.
      const res = []
      const map = new Map()
      for (const result of results) {
        if (!map.has(result.reportId)) {
          map.set(result.reportId, true)
          res.push(result)
        }
      }
      return res
    }
  },
  watch: {
    results () {
      // reset results checkbox each time we results change but avoid to do it when facette reload.
      let objectIdStr = JSON.stringify(this.results.map(r => r.objectID))
      if (this.previousResults !== objectIdStr) {
        let newResultsCheckbox = {}
        this.results.map(r => { newResultsCheckbox[r.objectID] = false })
        this.setResultsCheckbox(newResultsCheckbox)
        this.setSelectAllCheckbox([false, true])
      }
      this.previousResults = objectIdStr
    }
  }
}
</script>
